module.exports = __webpack_public_path__ + "static/media/postcard6thumb.501b8761.jpg";